// libs
import { useSubscription } from '@apollo/client/react'
// hooks
import { useCurrentUser } from 'hooks/useCurrentUser'
import { useApolloClient } from 'hooks/useApolloClient'
// graphql
import { CHART_DATA_QUERY } from 'graphql/chart/queries'
import { APP_NOTIFICATION } from 'graphql/notifications/subscriptions'
// types
import { NotificationType } from 'constants/notifications'
import { INotification } from 'types/graphql'

// A chart whose numbers were COMPUTING or REFRESHING gets the new ones. After a failed job (status FAILED) the fetch
// answers the stored error to show on the tile
export const useChartNotifications = () => {
  const { client } = useApolloClient()

  const { id: userId, company } = useCurrentUser()

  useSubscription<{ notification: INotification }>(APP_NOTIFICATION, {
    shouldResubscribe: true,
    skip: !userId || !company?.domainName,
    variables: { eventType: `${userId}:${company?.domainName}` },
    // Per message, not per render: two charts finishing together are both handled
    onData: ({ data }) => {
      const notification = data.data?.notification?.payload

      if (notification?.notificationType !== NotificationType.ChartDataUpdated) {
        return
      }

      const { chartId } = notification

      // Only a tile on screen fetches again; another one reads the new snapshot when it mounts
      client.refetchQueries({
        include: [CHART_DATA_QUERY],
        onQueryUpdated: (query) => query.variables?.chartId === chartId
      })
    }
  })
}
